import { render, staticRenderFns } from "./GradeSubject.vue?vue&type=template&id=1b21aa06"
import script from "./GradeSubject.vue?vue&type=script&lang=js"
export * from "./GradeSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports